module.exports = __webpack_public_path__ + "img/Weapon_133.63d41892.png";